import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'

interface BranchComparisonItem {
  sucursal: string
  ventas: number
  utilidad: number
}

interface BranchComparisonChartProps {
  data: BranchComparisonItem[]
}

function truncate(str: string, maxLen = 14): string {
  return str.length > maxLen ? str.slice(0, maxLen) + '…' : str
}

export function BranchComparisonChart({
  data,
}: BranchComparisonChartProps) {
  const chartHeight = data.length > 5 ? 320 : 250

  const displayData = data.map((d) => ({
    ...d,
    sucursal: truncate(d.sucursal),
  }))

  return (
    <div className="rounded-lg border border-border bg-card p-6">
      <h3 className="mb-4 font-semibold text-card-foreground">
        Comparativo entre Sucursales
      </h3>

      <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart
          data={displayData}
          margin={{ top: 4, right: 8, left: 0, bottom: data.length > 4 ? 32 : 0 }}
          barCategoryGap="30%"
        >
          <CartesianGrid
            strokeDasharray="3 3"
            stroke="var(--border)"
          />

          <XAxis
            dataKey="sucursal"
            stroke="var(--card-description)"
            tick={{
              fill: 'var(--card-description)',
              fontSize: data.length > 5 ? 10 : 12,
            }}
            angle={data.length > 4 ? -35 : 0}
            textAnchor={data.length > 4 ? 'end' : 'middle'}
            interval={0}
          />

          <YAxis
            stroke="var(--card-description)"
            tick={{ fill: 'var(--card-description)' }}
            fontSize={12}
            width={60}
          />

          <Tooltip
            cursor={{ fill: 'rgba(255,255,255,0.10)' }}
            contentStyle={{
              backgroundColor: 'var(--card)',
              border: '1px solid var(--border)',
              borderRadius: '8px',
              color: 'var(--card-foreground)',
            }}
            labelStyle={{
              color: 'var(--card-foreground)',
              fontWeight: 600,
            }}
            labelFormatter={(_, payload) =>
              payload?.[0]?.payload
                ? data.find(
                  (d) =>
                    truncate(d.sucursal) === payload[0].payload.sucursal,
                )?.sucursal ?? payload[0].payload.sucursal
                : ''
            }
          />

          <Legend
            wrapperStyle={{ fontSize: 12, color: 'var(--card-description)' }}
          />

          <Bar
            dataKey="ventas"
            name="Ventas"
            fill="#3b82f6"
            radius={[4, 4, 0, 0]}
          />

          <Bar
            dataKey="utilidad"
            name="Utilidad"
            fill="#10b981"
            radius={[4, 4, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}